// extracted by mini-css-extract-plugin
module.exports = {"bvpPlayerIframe":"_97d6423"};